import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const programsData = {
  'Undergraduate Programs': [
    {
      title: 'B.Tech Engineering',
      image: 'assets/program/1-min.png',
      details: (
        <ul className="list-disc pl-5 space-y-1">
          <li>
            <strong>Computer Science & Engg. (Core): </strong> Specialization -
            Artificial Intelligence & Machine Learning | Full Stack Development
            | Cyber Security | Data Science
          </li>
          <li>
            <strong>Electronics & Communication Engg.:</strong> Specialization -
            IoT | Robotics | Embedded Systems & VLSI
          </li>
          <li>
            <strong>Mechanical Engg.</strong> | Mining Engg. in Surface Mine
            Planning | Civil Engg. | Biotechnology
          </li>
        </ul>
      ),
    },
    {
      title: 'Management & Commerce',
      image: 'assets/program/2-min.png',
      details: (
        <ul className="list-disc pl-5 space-y-1">
          <li>
            BBA in Business Analytics in association | Marketing Management in
            association | Entrepreneurship Development | Hospitality Management
            | Digital Marketing | Tourism | Finance in association
          </li>
        </ul>
      ),
    },
    {
      title: 'Design',
      image: 'assets/program/3-min.png',
      details: (
        <ul className="list-disc pl-5 space-y-1">
          <li>
            <strong>B.Des </strong> - Software Design - UI & UX
          </li>
          <li>
            <strong>B.Des </strong> - Gaming, Animation & Metaverse
          </li>
        </ul>
      ),
    },
    {
      title: 'BCA',
      image: 'assets/program/4-min.png',
      details: (
        <ul className="list-disc pl-5 space-y-1">
          <li>Bachelor in Computer Applications (Hons.)</li>
        </ul>
      ),
    },
  ],
  'Postgraduate Programs': [
    {
      title: 'Management',
      image: 'assets/program/5-min.png',
      details: (
        <ul className="list-disc pl-5 space-y-1">
          <li>
            <strong>MBA </strong>
          </li>
          <li>
            <p>
              <strong>MBA in Business Analytics </strong>
            </p>
            <p className="text-[12px] italic">
              (Regular / Working Professionals)
            </p>
          </li>
        </ul>
      ),
    },
    {
      title: 'M.Tech Engineering',
      image: 'assets/program/6-min.png',
      details: (
        <ul className="list-disc pl-5 space-y-1">
          <li>
            <p>
              Computer Science Engg. | Electronics & Communication Engg. |
              Mechanical Engg. | Electrical Engg. | Civil Engg. | Mining Engg.
            </p>
            <p className="text-[12px] italic">
              (Regular / Working Professionals)
            </p>
          </li>
        </ul>
      ),
    },
    {
      title: 'M.Sc',
      image: 'assets/program/7-min.png',
      details: (
        <ul className="list-disc pl-5 space-y-1">
          <li>
            <p>
              <strong>M.Sc. in Applied Physics</strong>
            </p>
            <p className="text-[12px] italic">
              (Regular / Working Professionals)
            </p>
          </li>
        </ul>
      ),
    },
  ],
  'Ph.D.': [
    {
      title: 'Engineering',
      image: 'assets/program/8-min.png',
      details: (
        <ul className="list-disc pl-5 space-y-1">
          <li className="::marker:block h-auto">
            Computer Science and Engg. | Applied Engg. Biotechnology |
            Electronics and Communication Engg. | Electrical Engg. | Mechanical
            Engg. | Applied Engg. Physics | Applied Engg. Chemistry | Applied
            Engg. Mathematics | Mining | Civil
          </li>
        </ul>
      ),
    },
    {
      title: 'Management',
      image: 'assets/program/9-min.png',
      details: (
        <ul className="list-disc pl-5 space-y-1">
          <li>
            MBC Organizational Behavior & Human Resources Management |
            Accounting & Finance | Business Analytics | Operations & Quantative
            Management
          </li>
        </ul>
      ),
    },
  ],
};

export default function ProgramsOffered() {
  const [activeTab, setActiveTab] = useState('Undergraduate Programs');
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="mx-auto md:px-10 px-4 py-8">
      <div className="flex justify-center">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#2c2087] mb-6 border-b-[3px] border-[#2c2087] py-1">
          Academic Offerings
        </h2>
      </div>

      <div className="bg-black py-1 mb-6 rounded-[15px] md:rounded-[100px] pl-[6px]">
        <div className="flex flex-wrap">
          {Object.keys(programsData).map((tab) => (
            <button
              key={tab}
              className={`px-4 py-4 text-sm font-semibold rounded-full transition-all duration-300 mx-1 ${
                activeTab === tab
                  ? 'bg-white text-black border-black shadow-lg'
                  : 'bg-black text-white border-white'
              }`}
              onClick={() => {
                setActiveTab(tab);
                setOpenIndex(null); // Reset open state when tab changes
              }}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6"
      >
        {programsData[activeTab].map((program, index) => (
          <div
            key={index}
            className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200"
          >
            <div
              onClick={() => toggleAccordion(index)}
              className="cursor-pointer"
            >
              <img
                src={program.image}
                alt={program.title}
                className="w-full h-96 object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-[#2d2d7b] text-white p-3 py-[12px] block justify-between items-center">
                <div className="text-center w-full flex justify-between px-2">
                  <span className="font-bold">{program.title}</span>
                  <span className="text-white text-xl font-bold">
                    {openIndex === index ? '–' : '+'}
                  </span>
                </div>
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3 }}
                      className="text-white text-sm px-2"
                    >
                      {program.details}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  );
}
